// EMPTY
export const isEmpty = (value: any) => value === null || value === undefined || value === "";
